export class TableActionModel {
	public label: string;
	public icon: string;
	public color: string;
	public action: string;
	public type: string;
}
